import { getCustomApiURL, setCustomApiURL } from './apiURL'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'

//TODO: implement more features and better style, it is mostly copy pasted from app code
const DeveloperList = () => {
    // const intl = useIntl()
    // const apiSplit = env.apiBaseUrl.split('/')
    // const apiVersion = apiSplit[apiSplit.length - 1]
    // const deviceId = deviceInfos.ID
    // const [airshipId, setAirshipId] = useState(undefined)
    // const [firebaseId, setFirebaseId] = useState(undefined)
    //
    // useEffect(() => {
    //     Airship.channel.getChannelId().then(id => setAirshipId(id))
    //     messaging()
    //         .getToken()
    //         .then(id => setFirebaseId(id))
    // }, [])
    //
    // return (
    //     <div>
    //             <div>
    //                 <h6>{intl.formatMessage({ id: 'deviceId' })}</h6>
    //                 <p>{deviceId}</p>
    //             </div>
    //
    //             <div>
    //                 <h6>{intl.formatMessage({ id: 'airshipId' })}</h6>
    //                 <p>{airshipId}</p>
    //             </div>
    //
    //             <div>
    //                 <h6>{intl.formatMessage({ id: 'firebaseId' })}</h6>
    //                 <p>{firebaseId}</p>
    //             </div>
    //
    //             <div>
    //                 <h6>{intl.formatMessage({ id: 'apiVersion' })}</h6>
    //                 <p>{apiVersion}</p>
    //             </div>
    //     </div>
    // )
    return null
}

export const DeveloperPage = () => {
    const [success, setSuccess] = useState(false)
    const [apiURL, setApiURL] = useState(
        getCustomApiURL({ isStorage: false }) ||
            process.env.REACT_APP_API_ENDPOINT
    )
    const [apiStorageURL, setApiStorageURL] = useState(
        getCustomApiURL({ isStorage: true }) || process.env.REACT_APP_STORAGE
    )
    const intl = useIntl()

    const handleSubmit = async () => {
        setSuccess(false)
        apiURL && setCustomApiURL(apiURL)
        apiStorageURL && setCustomApiURL(apiStorageURL, true)
        setSuccess(true)
    }

    const handleReset = async () => {
        setSuccess(false)
        setApiURL(process.env.REACT_APP_API_ENDPOINT)
        setCustomApiURL(process.env.REACT_APP_API_ENDPOINT ?? '')

        setApiStorageURL(process.env.REACT_APP_STORAGE)
        setCustomApiURL(process.env.REACT_APP_STORAGE ?? '', true)
        setSuccess(true)
    }

    return (
        <div>
            <div>
                <h1>{intl.formatMessage({ id: 'developer.button.label' })}</h1>
            </div>

            <h2>{intl.formatMessage({ id: 'apiUrl' })}</h2>
            <input
                name="api"
                //placeholderKey="developer.api.label"
                value={apiURL}
                onChange={ev => setApiURL(ev.target.value)}
            />

            {/*<Spacer />*/}

            <h2>{intl.formatMessage({ id: 'storageApiURL' })}</h2>
            <input
                name="apiDlv"
                // placeholderKey="developer.storage.api.label"
                value={apiStorageURL}
                onChange={ev => setApiStorageURL(ev.target.value)}
            />

            {success && (
                <p>{intl.formatMessage({ id: 'developer.form.success' })}</p>
            )}

            {/*<Spacer size={SIZE.XS} />*/}

            <button type="submit" onClick={handleSubmit}>
                <h5 color="white">
                    {intl.formatMessage({ id: 'form.button.valid' })}
                </h5>
            </button>

            {/*<Spacer size={SIZE.XS} />*/}

            <button type="submit" onClick={handleReset}>
                {' '}
                <h5>{intl.formatMessage({ id: 'filters.button.reset' })}</h5>
            </button>

            {/*<Spacer />*/}

            <DeveloperList />
        </div>
    )
}
//
// const Container = styled.ScrollView`
//     margin: 20px;
// `
//
// const Title = styled.View`
//     margin: 10px auto 30px;
// `
//
// const StyledTextInput = styled.TextInput`
//     font-family: ${fonts.roboto};
//     margin-top: 5px;
//     padding: 10px;
//     border-color: ${shadow};
//     border-width: 1px;
//     border-radius: 5px;
// `
//
// const StyledMediumButton = styled(Link)`
//     ${style.buttonMedium};
//     background: ${props => props.color};
//     align-self: center;
//     width: 200px;
//     display: flex;
//     justify-content: center
//     align-items: center;
// `
//
// const SuccessMessage = styled(Text)`
//     color: ${colors.crunchyGreen};
//     margin: 10px auto;
// `
//
// const StyledView = styled.View`
//     margin-top: 20px;
// `
